import React from 'react';
import StyledSelect from '../StyledSelect';
var SelectDatasource = function (_a) {
    var selected = _a.selected, selectDatasetHandler = _a.selectDatasetHandler, options = _a.options, isDisabled = _a.isDisabled;
    if (!options) {
        return React.createElement(StyledSelect, { value: selected, onChange: selectDatasetHandler, isDisabled: isDisabled });
    }
    return React.createElement(StyledSelect, { value: selected, onChange: selectDatasetHandler, options: options });
};
export default SelectDatasource;
